export default [
  {
    _name: 'CSidebarNav',
    _children: [
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Home',
      //   to: '/portfolio',
      //   //icon: 'cil-home',
      //   fontIcon: 'fas fa-home-alt',
      // },
      {
        _name: 'CSidebarNavItem',
        name: 'Home',
        to: '/home',
        //icon: 'cil-home',
        fontIcon: 'fas fa-house-chimney',
      },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Lists',
      //   to: '/portfolio',
      //   //icon: 'cil-home',
      //   fontIcon: 'fas fa-list',
      // },
      {
        _name: 'CSidebarNavItem',
        name: 'Events',
        to: '/events',
        fontIcon: 'fas fa-cloud-exclamation',
        // icon: 'IconEvents'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Deliverables',
        to: '/deliverables',
        // icon: 'cil-home',
        fontIcon: 'fas fa-file-chart-column',
        // items:[
        //   {_name: 'CSidebarNavItem', name:'Project Report',to:'/deliverables/projectReport'},
        //   {_name: 'CSidebarNavItem', name:'SLA Uptime Report',to:'/deliverables/sla-report'},
        //   {_name: 'CSidebarNavItem', name:'TAM Report',to:'/deliverables/tam-report'}
        // ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'API Documentation',
        to: '/apiDoc',
        //icon: 'cil-home',
        fontIcon: 'fas fa-database',
      },
    ]
  }
]